import React, { useEffect, useState } from "react";
import { Grid, Typography, Container } from "@mui/material";
import ProductCard from "./show-list/ProductCard";
import ClearAllButton from "./show-list/ClearAllButton";
import FilterList from "./show-list/FilterList"; // Import the FilterList component
import isMobile from "./isMobile";

const ShowList = () => {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [editIndex, setEditIndex] = useState(null);
  const [newQuantity, setNewQuantity] = useState(null);
  const mobileView = isMobile();

  useEffect(() => {
    document.title = "Saved Products | Savepenny";
    const products = JSON.parse(localStorage.getItem("products")) || [];
    if (products && products.length > 0) {
      setData(products);
      setFilteredData(products); // Initially set filteredData to all products
    }
  }, []);

  const deleteItem = (e, item) => {
    e.preventDefault();
    const updatedList = data.filter((product) => product.id !== item.id);
    localStorage.setItem("products", JSON.stringify(updatedList));
    setTimeout(() => {
      setData(updatedList);
      setFilteredData(updatedList);
    }, 2000); // Update filtered data as well
  };

  const clearAll = () => {
    localStorage.removeItem("products");
    setData([]);
    setFilteredData([]); // Clear filtered data
  };

  const handleEditQuantity = (index) => {
    setEditIndex(index);
    setNewQuantity(filteredData[index].quantity || 1);
  };

  const handleSaveQuantity = (index) => {
    // Update the main data array
    const updatedData = [...data];
    const itemToUpdate = filteredData[index];
    const mainDataIndex = data.findIndex((item) => item.id === itemToUpdate.id);

    if (mainDataIndex !== -1) {
      updatedData[mainDataIndex].quantity = newQuantity;
      localStorage.setItem("products", JSON.stringify(updatedData));
      setData(updatedData);

      // Update filteredData while maintaining filters
      const currentFilters = getCurrentFilters(); // You'll need to track current filters
      let newFilteredData = [...updatedData];

      // Reapply current filters
      if (currentFilters.company) {
        newFilteredData = newFilteredData.filter((item) => {
          const merchant = item.merchant || item.merchant_name;
          return merchant === currentFilters.company;
        });
      }

      if (currentFilters.priceRange) {
        newFilteredData = newFilteredData.filter(
          (item) =>
            item.current_price >= currentFilters.priceRange[0] &&
            item.current_price <= currentFilters.priceRange[1]
        );
      }

      if (currentFilters.name) {
        newFilteredData = newFilteredData.filter((item) =>
          item.name.toLowerCase().includes(currentFilters.name.toLowerCase())
        );
      }

      setFilteredData(newFilteredData);
    }

    setEditIndex(null);
  };

  // Add state to track current filters
  const [currentFilters, setCurrentFilters] = useState({
    company: "",
    priceRange: null,
    name: "",
  });

  // Function to get current filters
  const getCurrentFilters = () => {
    return currentFilters;
  };

  // Update handleFilterChange to track current filters
  const handleFilterChange = (filters) => {
    setCurrentFilters(filters); // Store current filters
    let filtered = [...data];

    // Filter by company
    if (filters.company) {
      filtered = filtered.filter((item) => {
        const merchant = item.merchant || item.merchant_name;
        return merchant === filters.company;
      });
    }

    // Filter by price range
    if (filters.priceRange) {
      filtered = filtered.filter(
        (item) =>
          item.current_price >= filters.priceRange[0] &&
          item.current_price <= filters.priceRange[1]
      );
    }

    // Filter by product name
    if (filters.name) {
      filtered = filtered.filter((item) =>
        item.name.toLowerCase().includes(filters.name.toLowerCase())
      );
    }

    setFilteredData(filtered);
  };

  const handleIncrement = () => {
    setNewQuantity((prev) => prev + 1);
  };

  const handleDecrement = () => {
    if (newQuantity > 1) {
      setNewQuantity((prev) => prev - 1);
    }
  };

  return (
    <Container sx={{ mt: 1 }}>
      <Typography
        variant={mobileView ? "h6" : "h4"}
        gutterBottom
        textAlign="center"
      >
        Your Saved Products
      </Typography>

      {/* Include the FilterList component */}
      <FilterList
        data={data}
        onFilterChange={handleFilterChange}
        filteredData={filteredData}
      />

      <Grid container spacing={0.5} mobi>
        {filteredData && filteredData.length > 0 ? (
          filteredData.map((item, index) => (
            <ProductCard
              item={item}
              index={index}
              editIndex={editIndex}
              newQuantity={newQuantity}
              handleEditQuantity={handleEditQuantity}
              handleSaveQuantity={handleSaveQuantity}
              handleIncrement={handleIncrement}
              handleDecrement={handleDecrement}
              deleteItem={deleteItem}
              data={filteredData}
              setData={setFilteredData}
            />
          ))
        ) : (
          <Grid item mt={3} xs={12}>
            <Typography
              variant={mobileView ? "p" : "h6"}
              style={{ fontWeight: "bold" }}
              color="text.secondary"
              align="center"
            >
              No Lists For Now, Add Items from the home!
            </Typography>
          </Grid>
        )}
      </Grid>
      {filteredData && filteredData.length > 0 && (
        <ClearAllButton clearAll={clearAll} />
      )}
    </Container>
  );
};

export default ShowList;
